import { Component } from '@angular/core';

@Component({
  selector: 'app-bank-icon',
  imports: [],
  templateUrl: './bank-icon.html',
  styleUrl: './bank-icon.scss',
})
export class BankIcon {

}
